// Returns the correct API base URL based on window.location.origin
export const getApiBaseUrl = () => {
  if (typeof window === "undefined") {
    throw new Error("no window found setting baseURL");
  }
  const origin = window.location.origin;
  if (origin.indexOf("localhost") > 0) {
    return "https://localhost:7245";
  } else if (
    origin.indexOf("biogain-dev-app") > 0 ||
    origin.indexOf("dev.app.biogain.ai") > 0
  ) {
    return "https://biogain-dev-api.azurewebsites.net";
  } else if (
    origin.indexOf("biogain-prod-app") > 0 ||
    origin.indexOf("app.biogain.ai") > 0
  ) {
    return "https://biogain-prod-api.azurewebsites.net";
  } else {
    throw new Error("Unknown origin, cannot set baseURL");
  }
};

// --- Axios instance with JWT interceptor ---
import axios from "axios";
import { msalInstance, scopes } from "@/lib/msal-config";

export const axiosWithAuth = (() => {
  const instance = axios.create();
  // Set baseURL
  instance.interceptors.request.use(function (config) {
    config.baseURL = getApiBaseUrl();
    return config;
  });
  // Add JWT access token to Authorization header
  instance.interceptors.request.use(async function (config) {
    try {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length === 0) {
        throw new Error("No authenticated user found");
      }
      const silentRequest = {
        scopes: scopes,
        account: accounts[0],
      };
      const response = await msalInstance.acquireTokenSilent(silentRequest);
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${response.accessToken}`;
      return config;
    } catch (error) {
      console.error("Failed to acquire token:", error);
      throw new Error("Authentication failed");
    }
  });
  return instance;
})();